import { connect } from 'react-redux'
import TeamMemberForm from '../../components/team-members/form/TeamMemberForm'
import { inviteTeamMember, updateTeamMember, fetchTeamMember } from '../../state/actions/team_members/index'
import { getCurrentOrganization } from '../../state/reducers/organizations'
import {
  IOrganizationTeamMemberInvite,
  IStoreState,
  IOrganizationTeamMember,
  IOrganizationTeamMemberUpdateDTO
} from '../../types/index'
import { buildOrganizationTeamMember } from 'src/state/selectors'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const selectedOrg = getCurrentOrganization(state)
  const matchedId = ownProps.match.params.id
  const currentTeamMember = state.teamMember.items[matchedId]
  return {
    teamMemberId: matchedId,
    currentTeamMember,
    selectedOrg,
    organizations: state.organizations.items,
    processing: state.teamMember.isProcessing,
    fetching: state.teamMember.isFetching
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSubmit: (teamMember: IOrganizationTeamMemberInvite) => {
      return dispatch(inviteTeamMember(teamMember))
    },
    onUpdate: (teamMember: IOrganizationTeamMemberUpdateDTO) => {
      return dispatch(updateTeamMember(teamMember))
    },
    fetchTeamMember: (id: string) => {
      return dispatch(fetchTeamMember(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberForm)



// WEBPACK FOOTER //
// ./src/containers/team-members/TeamMemberCreateForm.ts